import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
    import { useEventListener, useMediaQuery, useVModel } from '@vueuse/core';
    import { TooltipProvider } from 'reka-ui';
    import { computed, type HTMLAttributes, type Ref, ref } from 'vue';
    import {
        provideSidebarContext,
        SIDEBAR_COOKIE_MAX_AGE,
        SIDEBAR_COOKIE_NAME,
        SIDEBAR_KEYBOARD_SHORTCUT,
        SIDEBAR_WIDTH,
        SIDEBAR_WIDTH_ICON,
    } from './utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarProvider',
  props: {
    defaultOpen: { type: Boolean, default: true },
    open: { type: Boolean, default: undefined },
    class: {}
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const isMobile = useMediaQuery('(max-width: 768px)');
    const openMobile = ref(false);

    const open = useVModel(props, 'open', emits, {
        defaultValue: props.defaultOpen ?? false,
        passive: (props.open === undefined) as false,
    }) as Ref<boolean>;

    function setOpen(value: boolean) {
        open.value = value; // emits('update:open', value)

        // This sets the cookie to keep the sidebar state.
        document.cookie = `${SIDEBAR_COOKIE_NAME}=${open.value}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
    }

    function setOpenMobile(value: boolean) {
        openMobile.value = value;
    }

    // Helper to toggle the sidebar.
    function toggleSidebar() {
        return isMobile.value ? setOpenMobile(!openMobile.value) : setOpen(!open.value);
    }

    useEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === SIDEBAR_KEYBOARD_SHORTCUT && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            toggleSidebar();
        }
    });

    // We add a state so that we can do data-state="expanded" or "collapsed".
    // This makes it easier to style the sidebar with Tailwind classes.
    const state = computed(() => (open.value ? 'expanded' : 'collapsed'));

    provideSidebarContext({
        state,
        open,
        setOpen,
        isMobile,
        openMobile,
        setOpenMobile,
        toggleSidebar,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TooltipProvider), { "delay-duration": 0 }, {
    default: _withCtx(() => [
      _createElementVNode("div", _mergeProps({
        "data-slot": "sidebar-wrapper",
        style: {
                '--sidebar-width': _unref(SIDEBAR_WIDTH),
                '--sidebar-width-icon': _unref(SIDEBAR_WIDTH_ICON),
            },
        class: 
                _unref(cn)(
                    'group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full',
                    // 'md:pl-[var(--sidebar-width-icon)]',
                    props.class,
                )
            
      }, _ctx.$attrs), [
        _renderSlot(_ctx.$slots, "default")
      ], 16)
    ]),
    _: 3
  }))
}
}

})